/**
 * Layout wrapper for authenticated admin pages.
 *
 * Phase: 4
 *
 * Provides a Mantine AppShell with header (project title + logout) and a left
 * navbar with links to top-level admin sections. Child routes render in <Outlet />.
 */

import {
  AppShell,
  Burger,
  Button,
  Group,
  NavLink as MantineNavLink,
  Stack,
  Title,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconCalendarEvent, IconLogout } from "@tabler/icons-react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { clearToken } from "../lib/auth";

export function AdminLayout() {
  const [opened, { toggle }] = useDisclosure();
  const navigate = useNavigate();
  const location = useLocation();

  function handleLogout() {
    clearToken();
    navigate("/admin/login", { replace: true });
  }

  return (
    <AppShell
      header={{ height: 60 }}
      navbar={{ width: 240, breakpoint: "sm", collapsed: { mobile: !opened } }}
      padding="md"
    >
      <AppShell.Header>
        <Group h="100%" px="md" justify="space-between">
          <Group gap="xs">
            <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
            <Title order={4}>maskder-sertifika · Yönetim</Title>
          </Group>
          <Button
            variant="subtle"
            color="gray"
            leftSection={<IconLogout size={16} />}
            onClick={handleLogout}
          >
            Çıkış
          </Button>
        </Group>
      </AppShell.Header>

      <AppShell.Navbar p="md">
        <Stack gap={4}>
          <MantineNavLink
            label="Etkinlikler"
            leftSection={<IconCalendarEvent size={18} />}
            active={location.pathname.startsWith("/admin/events")}
            onClick={() => navigate("/admin/events")}
          />
        </Stack>
      </AppShell.Navbar>

      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
}
